import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram, ArrowUpRight, Play, Layers } from "lucide-react";
import { CONTACT } from "../data/site";

const API = process.env.REACT_APP_BACKEND_URL;
const profile = `https://instagram.com/${CONTACT.instagram}`;

const PostTile = ({ p, i }) => (
  <motion.a
    href={p.permalink}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`instagram-post-${i}`}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
    className="group relative block aspect-square overflow-hidden bg-paper-2"
  >
    <img src={p.image_url} alt={(p.caption || "Trabalho Alfa Gráfica Digital").slice(0, 100)} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-105" />
    {p.media_type === "VIDEO" && <Play className="absolute top-3 right-3 h-5 w-5 text-paper drop-shadow" fill="currentColor" />}
    {p.media_type === "CAROUSEL_ALBUM" && <Layers className="absolute top-3 right-3 h-5 w-5 text-paper drop-shadow" />}
    <span className="absolute inset-0 flex items-end bg-ink/0 p-4 opacity-0 transition-[opacity,background-color] duration-300 group-hover:bg-ink/60 group-hover:opacity-100">
      <span className="line-clamp-3 text-xs sm:text-sm text-paper">{p.caption}</span>
    </span>
  </motion.a>
);

export const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    if (!API) return undefined;
    let alive = true;
    fetch(`${API}/api/instagram/feed?limit=8`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive) setPosts(Array.isArray(d?.data) ? d.data : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!posts.length) return null;

  return (
    <section id="instagram" data-testid="instagram-section" className="px-5 sm:px-10 py-20 lg:py-28">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-soft">( Instagram )</p>
          <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl leading-[0.95]">Siga a Alfa Gráfica<br /><em className="text-alga">no Instagram</em>.</h2>
          <p className="mt-4 max-w-md text-sm sm:text-base text-ink-soft">E veja os últimos trabalhos realizados.</p>
        </div>
        <a href={profile} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow-btn" className="group self-start sm:self-auto inline-flex items-center gap-4 rounded-full bg-ink text-paper pl-5 pr-2 py-2 text-sm font-bold uppercase tracking-wide transition-[background-color,transform] duration-300 hover:bg-alga active:scale-95">
          <Instagram className="h-4 w-4" /> @{CONTACT.instagram}
          <span className="grid place-items-center h-9 w-9 rounded-full bg-alga text-paper transition-[background-color,transform] duration-500 group-hover:bg-ink group-hover:rotate-45"><ArrowUpRight className="h-4 w-4" /></span>
        </a>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
        {posts.map((p, i) => <PostTile key={p.id} p={p} i={i} />)}
      </div>
    </section>
  );
};
